<template>
  <div id="Dingweizoushi">
    <div class="tr-header">
      <p class="title">{{betType == 'PK10'? '位置走势':'定位走势'}}</p>
      <div class="handles" v-if="betType != 'xyrb' && betType != 'ks'">
        <span
          @click="handleChecked('today', '0')"
          :class="{'checked': checked === '0'}"
          class="handle"
        >今天</span>
        <span
          @click="handleChecked('yesterday', '1')"
          :class="{'checked': checked === '1'}"
          class="handle"
        >昨天</span>
        <span
          @click="handleChecked('beforeYesterday', '2')"
          :class="{'checked': checked === '2'}"
          class="handle"
        >前天</span>
        <span
          @click="handleChecked('30', '3')"
          :class="{'checked': checked === '3'}"
          class="handle"
        >最近 30 期</span>
        <span
          @click="handleChecked('60', '4')"
          :class="{'checked': checked === '4'}"
          class="handle"
        >最近 60 期</span>
        <span
          @click="handleChecked('90', '5')"
          :class="{'checked': checked === '5'}"
          class="handle"
        >最近 90 期</span>
      </div>
    </div>
    <div class="tr-table-container">
      <div v-if="betType != 'ks'" class="check_box_one">
        <span>选择名次:</span>
        <div v-if="dataSource.length > 0">
          <span
            :class="{'checked_button': ballIndex == i}"
            class="handle"
            v-for="(it,i) in dataSource[0].ballList"
            :key="i"
            @click="handleBallChecked(i)"
          >第{{i+1}}球</span>
        </div>
      </div>
      <div class="check_box">
        <span>标注选择:</span>
        <CheckboxGroup v-model="showList" @on-change="checkAllGroupChange">
          <Checkbox label="yilou">遗漏</Checkbox>
          <Checkbox label="zhexian">折线</Checkbox>
          <Checkbox label="yifen">遗漏分成</Checkbox>
        </CheckboxGroup>
      </div>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :loading="isLoading" :columns="columns" :data="dataSource" border></Table>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="lostColumns" :data="lostList" border></Table>
      <div class="food_div" v-html="describe">
        <p>奇偶：除2余数为1的为奇数，含1、3、5、7、9，除2余0的为偶数，含2、4、6、8、10。</p>
        <p>大小：6、7、8、9、10为大数，1、2、3、4、5为小数。</p>
        <p>质合：1、2、3、5、7为质数，4、6、8、9、10为合数。</p>
        <p>012路：除3余数为0的为0路号码，包含3、6、9,；除3余数为1的为1路号码，包含1、4、7、10；除3余数为2的为2路号码，包含2、5、8。</p>
        <p>升平降：比上期奖号数值大的，表示本期奖号特征为升；与上期相同的，表示本期奖号特征为平；比上期奖号数值小的，表示本期奖号特征为降。</p>
        <p>分隔线：每五期使用分隔线，使横向导航更加清晰。</p>
        <p>出现总次数：统计期数内实际出现的次数。</p>
        <p>遗漏：自上期开出到本期间隔的期数。</p>
        <p>平均遗漏：统计期数内遗漏的平均值。（计算公式：平均遗漏＝统计期数/(出现次数+1)。）</p>
        <p>最大遗漏：统计期数内遗漏的最大值。</p>
        <p>当前遗漏：自上期开出到当前期所间隔的期数。</p>
        <p>最大连出值：统计期数内连续开出的最大值。</p>
      </div>
    </div>
  </div>
</template>

<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";

export default {
  name: "Dingweizoushi",
  data() {
    return {
      isLoading: false,
      // ball: ["一", "二", "三", "四", "五"],
      showList: ["yilou", "zhexian"],
      columns: [],
      pageSize: 30,
      dataSource: [],
      checked: "3",
      checkedButton: "6",
      ballIndex: 0,
      lostColumns: [],
      lostList: [],
      startDate: "",
      divideList: [],
      describe: ""
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.getDate();
      }
    }
  },
  methods: {
    checkAllGroupChange() {
      var lostList = document.querySelectorAll(".lost_info");
      var canvas = document.querySelector(".cvs_container");
      var divide = document.querySelectorAll(".divide_lost_info");
      for (let i = 0; i < divide.length; i++) {
        const e = divide[i];
        e.parentNode.parentNode.classList.remove("lost_active");
      }
      if (!this.showList.includes("yilou")) {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];
          e.style.display = "none";
        }
      } else {
        for (let i = 0; i < lostList.length; i++) {
          const e = lostList[i];
          e.style.display = "inline-block";
        }
      }
      if (!this.showList.includes("zhexian")) {
        canvas.style.display = "none";
      } else {
        canvas.style.display = "inline-block";
      }
      if (this.showList.includes("yifen")) {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.add("lost_active");
        }
      } else {
        for (let i = 0; i < divide.length; i++) {
          const e = divide[i];
          e.parentNode.parentNode.classList.remove("lost_active");
        }
      }
    },
    handleChecked(agt, index) {
      this.startDate = "";
      this.pageSize = "";
      this.checked = index;
      if (agt == "today") {
        this.startDate = dayjs().format("YYYY-MM-DD");
      } else if (agt == "yesterday") {
        // date -= 1;
        this.startDate = dayjs()
          .add(-1, "day")
          .format("YYYY-MM-DD");
      } else if (agt == "beforeYesterday") {
        this.startDate = dayjs()
          .add(-2, "day")
          .format("YYYY-MM-DD");
      } else if (agt == "30") {
        this.pageSize = 30;
      } else if (agt == "60") {
        this.pageSize = 60;
      } else if (agt == "90") {
        this.pageSize = 90;
      }
      this.getDate();
    },
    handleBallChecked(i) {
      this.ballIndex = i;
      this.getDate();
    },
    reset(data) {
      this.columns = columns(this.betType, data, this.ballIndex).list(this);
      this.lostColumns = columns(this.betType, data, this.ballIndex).lostList(
        this
      );
      this.describe = columns(this.betType, data).describe;
    },
    async getDate() {
      let req = {
        gameType: this.$route.params.gameType,
        isNeed: 1,
        num: this.pageSize,
        date: this.startDate
      };
      this.isLoading = true;
      this.dataSource = [];
      let res = await this.$http.post("/queryKcReportByIssue.do", req);
      if (res.data.returnCode == "0000") {
        this.isLoading = false;
        var arr;
        if (this.betType == "ks") {
          arr = format.formatKsDingwei(res.data.returnList, this.ballIndex);
        } else {
          arr = format.formatSscDingwei(res.data.returnList, this.ballIndex);
        }
        this.lostList = format.formatLost(res.data.returnMap);
        this.formatLost(arr);
        this.dataSource = arr;
        // console.log(arr, "arrrr");

        this.reset(arr);
        this.$nextTick(() => {
          // window.scrollTo(0, 0);
          var canvas = document.querySelector(".cvs_container");
          let table = document.querySelector(".ivu-table-tbody");
          if (canvas) {
            table.removeChild(canvas);
          }
          this.createCanvas();
          this.checkAllGroupChange();
        });
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatLost(arg) {
      var name = `ball${this.ballIndex + 1}`;
      this.divideList = arg[0].ball_json[name].nums;
    },
    // 走势图
    createCanvas() {
      let tableContent = document.querySelector(".tr-table-container");
      let table = document.querySelector(".ivu-table-tbody");

      let tablePos = table.getBoundingClientRect();
      let tableleft = tablePos.left;
      let tabletop = tablePos.top;
      //设置画布
      let cvs = document.createElement("canvas");
      cvs.style.marginTop = -table.offsetHeight + "px";
      cvs.className = "cvs_container";
      cvs.height = table.offsetHeight; // 表格的高度等同画布高度
      cvs.width = table.scrollWidth; // 表格的高度等同画布高度
      var redList = document.querySelectorAll(".red");
      let length;
      if (this.betType == "ks") {
        length = this.dataSource[0].ballList.length; // 开奖球数 5  就是列数
      } else {
        length = 1; // 只有 1 列
      }
      let redLength = redList.length; // 中奖号码球数 150
      let canvasArr = []; // 画笔坐标系
      for (let i = 0; i < length; i++) {
        canvasArr[i] = new Array();
        for (let j = 0; j < this.dataSource.length; j++) {
          var num = i + length * j;
          let dom = redList[num];
          let pos = dom.getBoundingClientRect();
          let left = pos.left + dom.offsetHeight / 2;
          let top = pos.top + dom.offsetWidth / 2;
          let a = { left: left - tableleft, top: top - tabletop - 15 };
          canvasArr[i].push(a);
        }
      }

      for (let i = 0; i < canvasArr.length; i++) {
        let colors = {
          0: "#fba75e",
          1: "#1fa6e8",
          2: "#0abe02",
          3: "#8485fb",
          4: "#46bd94",
          5: "#e16baa",
          6: "#f2b653",
          7: "#628ef3",
          8: "#5ec642",
          9: "#f66d6d"
        };
        let color = colors[i];
        let cxt = cvs.getContext("2d"); // 画笔
        cxt.strokeStyle = color; // 颜色
        cxt.beginPath();
        let it = canvasArr[i];
        if (it.length > 0) {
          cxt.moveTo(it[0].left, it[0].top);
          for (let j = 0; j < it.length; j++) {
            cxt.lineTo(it[j].left, it[j].top);
            cxt.stroke();
          }
        }
      }
      table.append(cvs); // 将绘画好的走势图接入表格dom树
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
/deep/.ivu-table-wrapper {
  min-width: 1160px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Dingweizoushi/index.vue